<template>
    <header>
        <div class="container">
            <div class="logo">
                <div class="filterTag" @click="filterHeaderTag(item.str)" v-for="(item, index) in filterTag" v-bind:key="index">
                    <div class="img_box">
                        <img :src="require(`@/assets/images/icon/${item.cover}.svg`)" />
                    </div>
                </div>
            </div>
            <!-- bootstrap + vue plugin start -->
            <b-navbar toggleable="md" type="dark" class="nav">
                <b-navbar-toggle target="nav_collapse" class="toggle-button"></b-navbar-toggle>
                <b-collapse is-nav id="nav_collapse" class="navbar-content">
                    <b-navbar-nav>
                        <b-nav-item
                            v-for="(classification, index) in classifications"
                            v-bind:key="index"
                            :to="{ name: 'products.index', params: { id: classification.TypeID } }">
                            {{ classification.TypeName }}
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <b-navbar toggleable="md" type="dark" class="login">
                <b-navbar-toggle target="login_collapse" class="login_controll"></b-navbar-toggle>
                <b-collapse is-nav id="login_collapse" class="text-right login_content">
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <div class="row">
                            <div class="col-12">
                                <template v-if="!isLogin">
                                    <b-nav-item 
                                        v-for="routes in HeaderLogIn"
                                        v-bind:key="routes.id"
                                        v-if="routes.text == '登入'"
                                        v-b-modal.login_modal>
                                        {{ routes.text }}
                                    </b-nav-item>
                                    <b-nav-item 
                                        v-bind:key="routes.id"img
                                        href="javascript:void(0)"
                                        v-else-if="routes.id == 0"
                                        v-b-modal.calendar_modal>
                                        <!-- v-b-modal.advanced_screening_modal -->
                                        {{ routes.text }}
                                    </b-nav-item>
                                    <b-nav-item v-bind:key="routes.id" :to="routes.to" v-else-if="routes.id == 1">
                                        {{ routes.text }}
                                        <span class="cartNum" v-if="productCount">{{ productCount }}</span>
                                    </b-nav-item>
                                    <b-nav-item v-bind:key="routes.id" :to="routes.to" v-else>
                                        {{ routes.text }}
                                    </b-nav-item>
                                </template>
                                <template v-else>
                                    <b-nav-item
                                        v-for="routes in HeaderLogIn"
                                        href="javascript:void(0)"
                                        v-bind:key="routes.id"
                                        v-if="routes.id == 0"
                                        v-b-modal.calendar_modal>
                                        {{ routes.text }}
                                    </b-nav-item>
                                    <b-nav-item v-bind:key="routes.id" :to="routes.to" v-else-if="routes.id == 1">
                                        {{ routes.text }}
                                        <span class="cartNum" v-if="productCount">{{ productCount }}</span>
                                    </b-nav-item>
                                    <b-nav-item
                                        v-bind:key="routes.id"
                                        :to="routes.to"
                                        v-show="routes.text == !'登入'"
                                        v-else>
                                        {{ routes.text }}
                                    </b-nav-item>
                                    <b-nav-item-dropdown right class="logout">
                                        <!-- Using button-content slot -->
                                        <template slot="button-content">
                                            <span>{{ name }}</span>
                                            <em>登出</em>
                                        </template>
                                        <div class="dropdown-menu_box">
                                            <b-dropdown-item 
                                                v-for="routes in HeaderLogOut"
                                                v-bind:key="routes.id"
                                                v-if="routes.text == '登出'"
                                                @click="logout()">
                                                {{ routes.text }}
                                            </b-dropdown-item>
                                            <b-dropdown-item v-bind:key="routes.id" :to="routes.to" v-else>
                                                {{ routes.text }}
                                            </b-dropdown-item>
                                        </div>
                                    </b-nav-item-dropdown>
                                </template>
                            </div>
                            <div class="col-12">
                                <b-nav-form>
                                    <b-form-input v-model="keyword" @keyup.enter.native="seach" size="sm" type="text" placeholder="搜尋..." autocomplete="off" />
                                    <b-button size="sm" class="login_search" type="button" @click="seach"></b-button>
                                </b-nav-form>
                            </div>
                        </div>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <!-- bootstrap + vue plugin end -->
            <div class="rwd_login">
                <router-link :to="{ name: 'cart.index' }" class="posr">
                    <span class="cartNum" v-if="productCount">{{ productCount }}</span>
                </router-link>
                <a v-b-modal.calendar_modal href="javascript:void(0)"></a>
            </div>
        </div>
        <div class="hbt_menu">
            <!-- bootstrap + vue plugin start -->
            <b-navbar-nav>
                <b-nav-item 
                    v-for="(classification, index) in classifications"
                    v-bind:key="index"
                    :to="{ name: 'products.index', params: { id: classification.TypeID } }">
                    {{ classification.TypeName }}
                </b-nav-item>
            </b-navbar-nav>
            <!-- bootstrap + vue plugin end -->
        </div>
    </header>
</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'; //自動抓getter我寫的  //可將vuex state抓進來
    import searchMixin from '@/mixins/search'
    
    export default {
        mixins: [searchMixin], // 跟search頁共用推入router網址的fn.
        computed: {
            ...mapGetters('user', [ //...打散ob,array
                'isLogin',
                'name',
                'avatar',
            ]),
            ...mapGetters('classifications', [
                'classifications',
            ]),
            ...mapGetters('cart', [
                'productCount',
            ]),
        },
        data() {
            return {
                HeaderLogIn: [{
                        id: 0,
                        text: '',
                        to: '#'
                    },
                    {
                        id: 1,
                        text: '',
                        to: {
                            name: 'cart.index'
                        },
                    },
                    {
                        id: 2,
                        text: '登入',
                        to: '#'
                    }
                ],
                HeaderLogOut: [{
                        id: 0,
                        text: '訂單/取消查詢',
                        to: {
                            name: 'orders',
                        },
                    },
                    {
                        id: 1,
                        text: '收藏課程',
                        to: {
                            name: 'collection',
                        }
                    },
                    {
                        id: 2,
                        text: '登出',
                        to: '/logout'
                    }
                ],
                keyword: '',
                filterTag: [{
                        str: 'B0',
                        cover: 'logo',
                    }
                ]
            }
        },
        created() {
            this.loadClassifications();

        },
        methods: {
            ...mapActions('classifications', [
                'loadClassifications'
            ]),
            ...mapMutations('user', [
                'setUser'
            ]),
            ...mapMutations('advancedSearch', [
                'setCompanyId',
            ]),
            logout() {
                this.setUser({});
            },
            filterHeaderTag(state) {
                if (state == 'A0')
                    this.$router.push({name: 'tlw_home'});
                else if (state == 'B0')
                    this.$router.push({name: 'hola_home'});
                else
                    this.$router.push({name: 'home'});
            }
        }
    };
</script>
